module.exports = __webpack_public_path__ + "img/dot.3897b3fa.svg";